import React, { Component } from 'react'
import Link from 'gatsby-link'
import ArrowIcon from '../components/svgs/arrow-right'
import Collapsible from '../components/collapsible'
import Slideshow from '../components/slideshow'
import plusOrange from '../images/svg/plus-orange.svg'
import plusBlack from '../images/svg/plus-black.svg'

import './ricercatore.sass'

export default class RicercatorePage extends Component {
  render() {
    const { pathContext } = this.props

    return (
      <div className="Ricercatore wrap-narrower">
        <h1 className="text-primary">{pathContext.titolo}</h1>

        <div className="Ricercatore__Body mt-4">
          <div className="Ricercatore__Body__Left with-arrow-icon">
            <Link className="Ricercatore__Arrow" to="/gruppo-di-ricerca">
              <ArrowIcon className="Ricercatore__Arrow" />
            </Link>

            {pathContext.contenuto &&
              pathContext.contenuto.map(block => (
                <div key={block.id}>
                  {block.model.apiKey === 'testo' && (
                    <div
                      className="text-size-1-2 mt-4"
                      dangerouslySetInnerHTML={{ __html: block.testo }}
                    />
                  )}

                  {block.model.apiKey === 'galleria_immagini' && (
                    <div className="Ricercatore__Slideshow mt-4">
                      <Slideshow images={block.immagini} />
                    </div>
                  )}

                  {block.model.apiKey === 'video' && (
                    <video
                      controls
                      src={block.video.url}
                      className="Evento__Video mt-4"
                    />
                  )}

                  {block.model.apiKey === 'download_pdf' && (
                    <div className="Evento__BtnDownloadPdfContainer mt-4">
                      <a
                        className="Evento__BtnDownloadPdf"
                        download
                        href={block.file.url}
                      >
                        {block.nomeDelDownload}
                      </a>
                    </div>
                  )}

                  {block.model.apiKey === 'blocco' &&
                    block.contenuti && (
                      <div className="Evento__Blocco mt-2" key={block.id}>
                        <Collapsible
                          isOpened={false}
                          title={() => <div>{block.contenuti.titolo}</div>}
                          collapsedIcon={plusBlack}
                          expandedIcon={plusOrange}
                          expandedColor="#c8c5b6"
                          titlePaddingLeft="0px"
                          id={`libro-${block.id}`}
                          onClick={this.handleCollapsibleClick}
                        >
                          {block.contenuti.contenuto.map(block => (
                            <div key={block.id}>
                              {block.model.apiKey === 'testo' && (
                                <div
                                  className="text-size-1-2 mb-4"
                                  dangerouslySetInnerHTML={{
                                    __html: block.testo,
                                  }}
                                />
                              )}

                              {/* {block.model.apiKey === 'galleria_immagini' && (
                              <div className="Ricercatore__Slideshow mb-4">
                                <Slideshow images={block.immagini} />
                              </div>
                            )} */}

                              {block.model.apiKey === 'video' && (
                                <video
                                  controls
                                  src={block.video.url}
                                  className="Evento__Video mb-4"
                                />
                              )}

                              {block.model.apiKey === 'download_pdf' && (
                                <div className="Evento__BtnDownloadPdfContainer mb-4">
                                  <a
                                    className="Evento__BtnDownloadPdf"
                                    download
                                    href={block.file.url}
                                  >
                                    {block.nomeDelDownload}
                                  </a>
                                </div>
                              )}
                            </div>
                          ))}
                        </Collapsible>
                      </div>
                    )}
                </div>
              ))}
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/templates/ricercatore.js